function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 18,
    rx: 6,
    ry: 6,
    style: {
      fill: "#ff9d64",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.17,12.54s-.04,0-.05,0c-.15-.01-.29-.07-.41-.15-.04-.03-.08-.06-.11-.1-.11-.13-.18-.3-.18-.48h0V7.54c0-.41,.34-.75,.75-.75s.75,.34,.75,.75v2.43l4.38-4.38c.29-.29,.77-.29,1.06,0s.29,.77,0,1.06l-4.38,4.38h2.43c.41,0,.75,.34,.75,.75s-.34,.75-.75,.75h-4.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.06,7.92s0,.05,.01,.08v-.07c0-.11,.02-.22,.06-.33-.05,.1-.07,.21-.07,.32Zm.84-1.18c-.25,.16-.63,.46-.77,.86,.15-.38,.54-.75,1.1-1.03-.11,.04-.23,.1-.33,.17Zm5.38,.27c.15,.14,.27,.29,.36,.44-.08-.15-.2-.3-.36-.44Zm.49,.91c0-.15-.04-.31-.13-.46,.08,.15,.12,.31,.12,.47v.07s.01-.05,.01-.08Zm-.05-2.45c-.9-.56-2.07-.86-3.3-.86-.48,0-.94,.04-1.37,.14,1.59-.29,3.41-.05,4.65,.72,.05,.03,.1,.06,.15,.1-.05-.03-.08-.07-.13-.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.24,7.59c-.02-.12-.04-.24-.08-.35h0c-.05-.17-.12-.33-.2-.48-.08-.15-.17-.3-.29-.44-.1-.13-.21-.24-.33-.35-.07-.07-.15-.14-.23-.2-.07-.06-.15-.12-.23-.17-.01,0-.02-.02-.03-.02-.05-.04-.1-.07-.15-.1-1.24-.77-3.06-1.01-4.65-.72-.15,.02-.29,.05-.43,.09-.14,.04-.28,.07-.41,.12-.06,.02-.11,.04-.17,.06-.39,.15-.75,.33-1.07,.55-.11,.07-.21,.15-.31,.23-.2,.17-.37,.34-.52,.53-.08,.09-.15,.19-.2,.29-.06,.1-.11,.21-.16,.31s-.08,.21-.11,.31c-.04,.11-.06,.22-.08,.33-.01,0-.01,.01,0,.02-.01,.11-.02,.22-.02,.34v2.27c0,1.81,2.08,3.18,4.85,3.18s4.84-1.34,4.84-3.18v-2.27c0-.12-.01-.24-.02-.35Zm-4.82,4.3c-1.77,0-3.26-.73-3.34-1.6,.87,.52,2.04,.82,3.33,.82s2.47-.3,3.34-.84c-.06,.89-1.53,1.62-3.33,1.62Zm3.34-3.88c-.01,.19-.1,.38-.25,.56-.53,.63-1.75,1.04-3.1,1.04s-2.55-.41-3.09-1.04c-.15-.18-.24-.37-.25-.56-.01-.03-.01-.05-.01-.08,0-.11,.02-.22,.07-.32,.14-.4,.52-.7,.77-.86,.1-.07,.22-.13,.33-.17,.17-.08,.34-.15,.53-.21,.19-.07,.39-.12,.6-.16,.33-.06,.68-.09,1.04-.09,.59,0,1.16,.09,1.67,.25,.1,.03,.21,.06,.3,.11,.1,.04,.19,.09,.29,.13,.09,.04,.18,.09,.26,.14,.13,.08,.25,.18,.36,.27,.16,.14,.28,.29,.36,.44h0c.09,.16,.13,.32,.13,.47,0,.03,0,.05-.01,.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56,7.92s0,.07,.01,.11v-.1c0-.12,.01-.23,.02-.34-.02,.11-.03,.22-.03,.33Zm.58-1.59c.15-.19,.32-.36,.52-.53-.21,.16-.38,.34-.52,.53Zm.96-.86s-.09,.06-.13,.1c.32-.22,.68-.4,1.07-.55-.34,.12-.66,.27-.94,.45Zm5.82,1.27c-.08-.05-.17-.1-.26-.14,.09,.05,.17,.1,.26,.15,.13,.08,.26,.17,.36,.26-.11-.09-.23-.19-.36-.27Zm2.35,1.18c0-.12-.01-.23-.03-.34,0,.11,.02,.23,.02,.35v.1s.01-.07,.01-.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.66,7.73c0,.07-.06,.14-.16,.17l-.58,.2-.31,.37c-.06,.06-.16,.11-.28,.11-.11,0-.21-.04-.27-.11l-.32-.37-.58-.2c-.1-.04-.16-.11-.16-.17,0-.07,.06-.14,.16-.17l.58-.2,.32-.38c.11-.13,.43-.13,.54,0l.31,.38,.58,.2c.1,.03,.16,.1,.16,.17Z",
    style: {
      fill: "#fff",
      isolation: "isolate"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenDeposit);
export default __webpack_public_path__ + "static/media/Token_deposit.b50558bee53d834141103e22c57329a5.svg";
export { ForwardRef as ReactComponent };